<template>
  <div class="w-full">
    <div class="flex flex-col sm:flex-row w-full">
      <div class="relative flex w-full text-center">
        <button
          type="button"
          :aria-label="$t('app.previous')"
          class="hidden sm:block cursor-pointer"
          @click="prevSlide"
        >
          <img
            :src="arrow"
            :alt="$t('app.previous')"
            class="rotate-180"
          />
        </button>
        <div
          v-for="(slide, index) in slides"
          :key="index"
          :class="{ hidden: index !== activeIndex }"
          class="w-full"
        >
          <transition name="fade">
            <div
              v-show="index === activeIndex"
              :class="contentHeight"
              class="flex flex-col justify-center items-center px-10"
            >
              <p
                :class="descriptionClasses"
                class="text-center text-2xl"
              >
                {{ slide.description }}
              </p>
              <img
                v-if="slide.image"
                :src="getAssetUrl(slide.image)"
                :alt="slide.imageAlt"
                class="mt-12"
              />
              <small
                v-if="slide.author"
                :class="{ 'text-white': isDark }"
                class="block mt-8 text-base leading-5 font-normal"
              >
                {{ slide.author }}
              </small>
            </div>
          </transition>
        </div>
        <button
          type="button"
          :aria-label="$t('app.next')"
          class="hidden sm:block cursor-pointer"
          @click="nextSlide"
        >
          <img
            :src="arrow"
            :alt="$t('app.next')"
          />
        </button>
      </div>
      <div
        v-if="arrows"
        class="sm:hidden mt-8 flex mx-auto space-x-6 h-[92px]"
      >
        <button
          type="button"
          :aria-label="$t('app.previous')"
          class="cursor-pointer"
          @click="prevSlide"
        >
          <img
            :src="arrow"
            :alt="$t('app.previous')"
            class="rotate-180"
          />
        </button>
        <button
          type="button"
          :aria-label="$t('app.next')"
          class="cursor-pointer"
          @click="nextSlide"
        >
          <img
            :src="arrow"
            :alt="$t('app.next')"
            class="-mt-0.5"
          />
        </button>
      </div>
    </div>
    <ul
      v-if="dots"
      class="flex items-center justify-center gap-2 mt-4"
    >
      <li
        v-for="(slide, i) in slides"
        :key="`slider-dot-${i}`"
      >
        <button
          type="button"
          :class="{
            'bg-neutral-200 hover:opacity-50': activeIndex !== i,
            'bg-bubblegum-500': activeIndex === i,
          }"
          class="size-2.5 rounded-full"
          @click="goToSlide(i)"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import readingTime from '@/helpers/readingTime';
import { getAssetUrl } from '@/helpers/url';

export default {
  name: 'VetsterInformationCarousel',

  props: {
    arrows: {
      type: Boolean,
      default: true,
    },
    contentHeight: {
      type: String,
      default: 'h-60 sm:h-64',
      required: false,
    },
    descriptionClasses: {
      type: String,
      default: '',
      required: false,
    },
    dots: {
      type: Boolean,
      default: false,
    },
    isDark: {
      type: Boolean,
      default: false,
    },
    slides: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      activeIndex: 0,
      autoSlideInterval: null,
      arrow: getAssetUrl('/images/arrows/straight-short-pink-arrow.svg'),
    };
  },

  watch: {
    activeIndex: {
      handler(i) {
        this.stopAutoSlide();

        const timeout = readingTime(this.slides[i].description) * 60000;

        this.autoSlideInterval = setInterval(this.nextSlide, timeout);
      },
      immediate: true,
    },
  },

  beforeDestroy() {
    this.stopAutoSlide();
  },

  methods: {
    getAssetUrl,
    goToSlide(index) {
      this.activeIndex = index;
    },
    stopAutoSlide() {
      clearInterval(this.autoSlideInterval);
    },
    prevSlide() {
      this.activeIndex = (this.activeIndex - 1 + this.slides.length) % this.slides.length;
    },
    nextSlide() {
      this.activeIndex = (this.activeIndex + 1) % this.slides.length;
    },
  },
};
</script>
